export default __webpack_public_path__ + "static/media/update.59a75380.svg";